import { EAttachesType } from 'reactApp/modules/attaches/attaches.constants';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

export enum EViewMode {
    thumbs = 'thumbs',
    list = 'list',
    gallery = 'gallery',
    galleryGrid3 = 'galleryGrid3',
}

export enum EViewStoreType {
    photo = 'ui.photoView',
    photoMobile = 'ui.photoViewMobile',
    files = 'ui.filesView',
    attaches = 'ui.attachesView',
    quotaCleaner = 'ui.quotaCleanerView',
}

export interface SettingsState {
    viewMode: EViewMode;
    prevViewMode: EViewMode;
    viewModePhoto: EViewMode;
    viewModePhotoMobile: EViewMode;
    viewModeAttaches: EViewMode;
    viewModeQuotaCleaner: EViewMode;
    queryParams: QueryParams;
}

export interface QueryParams {
    query?: string;
    folderId?: string;
    productId?: string;
    tariffId?: string;
    weblink?: string;
    type?: EAttachesType;
    fromAuth?: boolean;
    sort?: string;
    item?: string;
    action?: string;
    diskoKey?: string;
    id?: string;
    searchType?: string;
    token?: string;
    max_size?: number;
    total_size?: number;
    afterReload?: boolean;
    from?: string;
    fromCloud?: boolean;
}

export interface ISetViewModeForStorageAction {
    viewMode: EViewMode;
    storage: EStorageType;
    isMediaFolder?: boolean;
}

export interface ISetViewModeAction {
    viewMode: EViewMode;
}
